export enum AttendanceLocalEnum {
    triagemVirtual = 1,
}